import state from '../state.js';

export function mapAndPushHistory(filter = null, e = null, page = null) {
    const params = $('form').serialize().split('&');

    let pair = null,
        data = [];

    params.forEach(function (d) {
        pair = d.split('=');
        data.push({ key: pair[0], value: pair[1] });
    });

    data = data.map((obj) => {
        if (filter && obj.key.includes(filter)) {
            obj.value = e.minValue + '%2C' + e.maxValue;
        }

        return obj;
    });

    let pageNumber = page === null ? 1 : page;

    if (page === null) {
        let extractPage = new URLSearchParams(window.location.search);

        const currentPage = extractPage.get('page');

        if (currentPage) {
            pageNumber = currentPage;
        }
    }

    if (filter === 'reset') {
        data = data
            .map((obj) => {
                if (obj.key !== 'search') {
                    if (obj.key.includes('kcal')) {
                        obj.value = 0 + '%2C' + 2000;
                    } else if (
                        obj.key.includes('fat') ||
                        obj.key.includes('protein') ||
                        obj.key.includes('carbohydrates')
                    ) {
                        obj.value = 0 + '%2C' + 200;
                    }
                }

                return obj;
            })
            .filter((obj) =>
                ['fat%5B%5D', 'protein%5B%5D', 'kcal%5B%5D', 'carbohydrates%5B%5D'].includes(obj.key)
            );

        pageNumber = 1;
    }

    let urlParam = Object.keys(data)
        .map((key) => {
            const obj = data[key];
            return obj.key + '=' + obj.value;
        })
        .join('&');

    urlParam = urlParam + '&page=' + pageNumber;

    state.recipeQueryString = urlParam;

    const obj = { title: 'Search', url: '/recept/sok?' + urlParam };

    history.pushState(obj, obj.title, obj.url);
}

export function getValueFromUrlOnLoad(type) {
    const search = window.location.search;

    let values = [],
        data = [];

    if (search.length) {
        values = search.split('&');

        data = values
            .map((each) => each.split('='))

            .map((each) => {
                let split = each[1].replace('%2C', '|');

                if (split.includes('|')) {
                    split = split.split('|');
                }

                return [each[0].replace('%5B%5D', ''), split];
            });

        if (data.length) {
            const res = data.find((each) => each[0] === type);

            if (res && res.length > 1) {
                return res[1];
            }
        }
    }

    return null;
}

export function perServing(ingredients) {

    let helper = {};

    return ingredients

        .filter((item) => item)

        .reduce(function (r, o) {

            let key = 'single-' + o.id

            if (o.food_item_id && o.unit_id) {
                key = o.food_item_id + '-' + o.unit_id
            } else if (o.food_item_id) {
                key = 'livsmedel-' + o.food_item_id
            }

            const obj = Object.assign({}, o);

            obj.per_serving = obj.quantity / obj.recipe.servings;

            if (!helper[key]) {
                helper[key] = Object.assign({}, obj);
                r.push(helper[key]);
            } else {
                helper[key].per_serving += obj.per_serving;
            }

            return r;

        }, []);

}
